// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"styles_sidebar__P-bOI","isOpen":"styles_isOpen__3d11h","body":"styles_body__3_aFY","exit":"styles_exit__3tiXz","commonSideLink":"styles_commonSideLink__1Spws"};